import { BvTableFieldArray } from 'bootstrap-vue';
import Vue from 'vue';

export const feedTankOverviewFields: BvTableFieldArray = [
	{ key: 'id', label: 'Id' },
	{ key: 'name', label: 'Name' },
	{
		key: 'nominalVolume',
		label: 'Nominal Volume',
		formatter: (nominalVolume: string | null) =>
			nominalVolume ? `${nominalVolume}L` : 'No nominal volume',
	},
	{
		key: 'status',
		label: 'Status',
		formatter: (status: string | null) => Vue.filter('titleCase')(status) ?? 'No status',
	},
];
